import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AlertService } from '@shared/services/alert.service';

export const UnauthorizedInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const alertService = inject(AlertService);
  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        alertService.unauthorizedAlert();
        authService.clearToken();
      }
      return throwError(() => error);
    }),
  );
};
